import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error js module
import { useIsEmbeddedContext } from 'customer-data-sidebar/universal/context/IsEmbeddedContext';
import { CrmLogger } from 'customer-data-tracking/loggers';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const PropertyHistoryButton = ({
  objectId,
  objectType,
  onShowPropertyHistory,
  property
}) => {
  const isEmbedded = useIsEmbeddedContext();
  if (isEmbedded) {
    return null;
  }

  // Hide if implementer doesn't want to show details button
  if (!onShowPropertyHistory) {
    return null;
  }
  const {
    name
  } = property;
  const handleOnClick = () => {
    CrmLogger.log('sidebar-interaction', {
      action: 'clicked property input history',
      type: objectType
    });
    onShowPropertyHistory({
      objectType,
      property,
      subjectId: objectId
    });
  };
  return /*#__PURE__*/_jsx(Button, {
    "data-selenium-test": `show-property-history__${name}`,
    onClick: handleOnClick,
    size: "extra-small",
    title: I18n.text('cardProperties.propertyHistoryLink'),
    use: "tertiary-light",
    marginInlineStart: "300",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardProperties.details"
    })
  }, "history");
};
export default PropertyHistoryButton;